import * as INR from "./INR.ts";
import * as Html from "./util/Html.ts";
import ApiServer from "./ApiServer.ts";
import { markInvalidNative } from "./util/forms.ts";
import * as modal from "./util/modal.ts";
import * as i18n from "./i18n.ts";
import {getStartSequence} from "./actions.ts";
import * as libLocation from "./lib/location.ts";
import * as ga from "./tracking-googleanalytics.ts";
import * as login from "./features/login.ts";
import FizConfig from "./FizConfig.ts";
import {OS} from "./lib/os.ts";
import deviceId from "./lib/deviceId.ts";
import * as Storage from "./lib/Storage.ts";
import { clearAuthorization } from "./server/Authorization.ts";

const PROMOCODE = JSON.parse(Storage.sessionGet('PROMOCODE')||"{\"ask\":false}");

async function createAccount(identifier :string,password :string){
  //lets make the api grouper makes its job
  const [accountLoginInfo] = await Promise.all([
    ApiServer.log2create(null,identifier,null,password),
    ApiServer.log2generateaccesstokenbypassword(undefined,identifier,undefined,password)
  ])
  Storage.sessionSet('needsegmentidentify','true');
  return accountLoginInfo;
}
var
  fw2Context : {ApiPromo ?:()=>Promise<any>} = {},
  invitationReceived,
  originalTitle = document.title,
  //define startSequence for page needing invitation
  startSequence = getStartSequence(false,function(callback,data){

    var
      iid = libLocation.getURLParam("iid"),
      v =  libLocation.getURLParam("v");
    if(invitationReceived===undefined && iid){
      //TODO find where it mights happens
      if(libLocation.getURLParam("logged")==="true"){
        ApiServer.famacceptinvitation(iid, v,function(invit) {
          libLocation.goTo(INR.URL.FW2_INVITATION_SUCCESS);
        });
        return;
      }
      ApiServer.famgetinvitation(iid, v, function(invit) {
        invitationReceived = invit;
        PROMOCODE.isInvit = true;
        invitationReceived.identifier=libLocation.getURLParam("identifier");

        ApiServer["custom.signuponinvite"] = async function(form){
          invitationReceived.identifier=form.a00identifier.value;
          try{
            await ApiServer.log2generateaccesstokenbypassword(form);
            ApiServer.famacceptinvitation.prepare(iid, v, "TOKEN",invitationSuccess, invitationError)
          }catch(e){
            await createAccount(form.a00identifier.value,form.a00password.value);
            ApiServer.group([
              ApiServer.accsetprofile.prepare({firstname:form.a01firstname.value}),
              ApiServer.accgetstate.prepare(deviceId, "WebFirebase", FizConfig.jsVersion||"",OS.getTimeZone()),
              ApiServer.accsetterms.prepare(true),
              ApiServer.famacceptinvitation.prepare(iid, v, "TOKEN"),
              ApiServer.accsendwelcomeemail
              ],invitationSuccess, invitationError)(form);
          }

        };
        ga.event("Join_fromEmail|Join_Email|$DEVICE_Join");

        if(invit.invitation.token.sms){
          ga.invitationevent("Invite_Member|C_Invitation_Clicked|From_SMS_Invitation")
        }else if(invit.invitation.token.email){
          ga.invitationevent("Invite_Member|C_Invitation_Clicked|From_Email_Invitation")
        }else{
          ga.invitationevent("Invite_Member|C_Invitation_Clicked|From_Whatsapp_Invitation")
        }


        callback(invitationReceived);
      }, invitationError);
    }else{
      callback(invitationReceived||fw2Context);
    }
  }),
  startSequenceWithFamilies = getStartSequence(false,function(callback,data){
    ApiServer.famlistfamily(function(famList) {
      data.families = famList;
      data.signup = PROMOCODE.signup;
      if(famList.length>1){
        data.multifamily = true;
      }
      callback(data);
    });
  }),
  startSequenceDeepLink = getStartSequence(false,function(callback,data){
    data = invitationReceived||data;
    function onError(){
      data.deepLoginLink = INR.URL.ENTER_HOME;
      callback(data);
    }
    ApiServer.accgetloggedaccount(function(acc){
      acc.identifiers.forEach(function(accIdentifier){
        if(accIdentifier.type==='Login') data.identifier = accIdentifier.value;
        if(accIdentifier.type==='Email') data.identifier = accIdentifier.value;
      });
      ApiServer.accdeeplink('home',function(link){
        data.deepLoginLink = link;
        data.signup = PROMOCODE.signup;
        callback(data);
      },onError);
    },onError);
  });




ApiServer.types.InvitationReceivedBean.prototype.urlParams = function(){
  return "?iid="+encodeURIComponent(this.iid)+"&v="+encodeURIComponent(this.v)+(this.identifier?"&identifier="+encodeURIComponent(this.identifier):"");
};

INR.createPage(
  INR.URL.FW2_INVITATION,
  startSequence,
  function(){
    return Promise.all([import('./nc/invitation.mustache')])
  },
  "fw2"
);
INR.createPage(INR.URL.FW2_SIGNUP,
    startSequence,
    function(){
      return Promise.all([import('./nc/signup.mustache')])
    },
    "fw2"
  );
INR.createPage(INR.URL.FW2_SIGNUP_FAMILY,
    startSequence,
    function(){
      return Promise.all([import('./nc/signup_family.mustache')])
    },
    "fw2"
  );
INR.createPage(
  INR.URL.FW2_SIGNIN,
  startSequence,
  function(){
    return Promise.all([import('./nc/signin.mustache')])
  },
  "fw2"
);

INR.createPage(
  INR.URL.FW2_INVITATION_PROFILE,
  startSequence,
  function(){
    return Promise.all([import('./nc/invitationprofile.mustache')])
  },
  "fw2"
);

INR.createPage(INR.URL.FW2_INVITATION_SUCCESS,
    startSequenceDeepLink,
    function(){
      return Promise.all([import('./nc/invitation_success.mustache')])
    },
    "fw2"
  );

INR.createPage(INR.URL.FW2_INVITATION_ERROR,
    startSequence,
    function(){
      return Promise.all([import('./nc/invitation_error.mustache')])
    },
    "fw2"
  );

INR.createPage(INR.URL.FW2_BLOCKINVITATION,
    startSequence,
    function(){
      return Promise.all([import('./nc/blockinvitation.mustache')])
    },
    "fw2"
  );
INR.createPage(INR.URL.FW2_BLOCKINVITATION_SUCCESS,
    startSequence,
    function(){
      return Promise.all([import('./nc/blockinvitation_success.mustache')])
    },
    "fw2"
  );

function invitationSuccess() {
  document.title = originalTitle;
  if (invitationReceived) {
    invitationReceived = undefined;
    ga.invitationevent("Invite_Member|D_Invitation_Accepted|Account_Created|1")
    ga.event("Join|Join_Completed|Join_completed");
    libLocation.goTo(INR.URL.FW2_INVITATION_SUCCESS);
  }else{
    libLocation.goTo(INR.URL.ACTIVITY);
  }
}
function signupSuccess() {
  ga.event({
    'event': 'signUpCompleted',
    'form_name': 'signup form'
  })

  let
    recipeToSave = getRecipeToSave();


  if(recipeToSave){
    ApiServer.mprecipeput(recipeToSave,recipeToSave.pictures,function(savedRecipe){
      Storage.sessionRemove('recipeToSave')
    })
  }
  if(PROMOCODE.ask /* || (!OS.hasApp && FizConfig.CONFIG_PARTNER_TYPE==='Family') */){ //asked by nf 20230103 users where asking support for a promocode
    PROMOCODE.signup = true;
    libLocation.goTo(INR.URL.FW2_PROMOCODE);
  }else if(OS.hasApp){
    PROMOCODE.signup = true;
    libLocation.goTo(INR.URL.FW2_INVITATION_SUCCESS);
  }else if(PROMOCODE.isInvit){
    libLocation.goTo(INR.URL.ENTER_HOME);
  }else{
    libLocation.goTo(INR.URL.ENTER_HOME+"?modal=welcome");
  }
}
function loginError(ex) {
  console.log(ex)
  if(ex.message === ""){
    modal.alert("fw2.apierrors.notconnected");
  }else if(ex.message === "timeout"){
    modal.alert("fw2.defaultError");
  }else if (ex.code === '12') {
    invitationSuccess()
  } else {
    modal.alert("errors.loginFailed");
  }
}
async function invitationError(ex) {
  console.log(ex)
  // account already exists
  if (ex.code === '2') {
    await modal.alert("fw2.apierrors.2");
    libLocation.goTo(INR.URL.FW2_SIGNIN);
  }else if (ex.code === '16' && ex.tokenType==='InvitationAccepted') {
    libLocation.goTo(INR.URL.FW2_INVITATION_SUCCESS);
  } else {
    ga.event("Invitation|Error|"+ex.message+"|"+ex.code);
    libLocation.goTo(INR.URL.FW2_INVITATION_ERROR);
  }
}
INR.onPage(INR.URL.FW2_INVITATION_SUCCESS, function() {
  libLocation.enable();
});
INR.onPage(INR.URL.FW2_INVITATION, function() {
  libLocation.disable();
  if (invitationReceived && invitationReceived.invitation.token.accountIdentifierId) {
    libLocation.goTo(INR.URL.FW2_SIGNIN);
    return;
  }
  document.title = i18n.get("fw2.invitation.title");
});
ApiServer["custom.invitationsetemail"] =  function(form){
  invitationReceived.firstname = form.firstname.value || invitationReceived.firstname;
  var identifier = form.a00identifier.value;
  ApiServer.log2check('Email',identifier,
    function(isFree){
      invitationReceived.identifier=identifier;
      ga.event("Join|Continue_Process|Continue_Process");
      if(isFree){
        libLocation.goTo(INR.URL.FW2_INVITATION_PROFILE+invitationReceived.urlParams());
      }else{
        invitationReceived.alreadymember = true;
        libLocation.goTo(INR.URL.FW2_SIGNIN);
      }
    },function(err){
      const input = document.querySelector('input[name=a00identifier]') as HTMLInputElement;
      markInvalidNative(input, i18n.get("invitationJs.errorEmail"));
    }
  );
}


ApiServer["custom.signin"] = ApiServer.group([
    ApiServer.log2generateaccesstokenbypassword,
    ApiServer.accgetloggedaccount
  ],async function(accountLoginInfo, iAccount){

  let
    recipeToSave = getRecipeToSave();

  if(!iAccount.termsChecked){
    libLocation.goTo(INR.URL.FW2_TERMS);

  }else if(PROMOCODE.ask){
    libLocation.goTo(INR.URL.FW2_PROMOCODE);

  }else if(recipeToSave){
    ApiServer.famlistfamily(true,function(families){
      if(families.length===1){

        ApiServer.mprecipeput(recipeToSave,recipeToSave.pictures,function(savedRecipe){
          Storage.sessionRemove('recipeToSave')
          libLocation.goTo("recipebox.php?id="+savedRecipe.metaId);
        })
      }else{
        libLocation.goTo("familypick.php");
      }
    })
  }else{
    //use window location to activate "Do you want to register login/password" popup from browser
    window.location.href=(INR.URL.ENTER_HOME+"?result=200");
  }

  },loginError);

INR.onPage(INR.URL.FW2_SIGNIN, function() {
  //login must use the Basic web key, never a stale Bearer token left in storage
  clearAuthorization();
  var apis = [ ApiServer.log2generateaccesstokenbypassword ];
  if (invitationReceived) {
    apis.push(ApiServer.famacceptinvitation.prepare(invitationReceived.iid, invitationReceived.v));
  }
  ApiServer["custom.signinoninvite"] = ApiServer.group(apis, function(){
    if (invitationReceived) {
      const identifierInput = document.querySelector("input[name='a00identifier']") as HTMLInputElement;
      invitationReceived.identifier = (identifierInput?.value) || invitationReceived.identifier;
    }
    invitationSuccess();
  }, loginError).setOptions({timeout:120000,defaultErrorHandler:function(e){throw e}});

});
INR.onPage(INR.URL.FW2_BLOCKINVITATION, function() {
  ApiServer["custom.blockinvitation"] = ApiServer.famblockinvite.prepare(invitationReceived.iid,invitationReceived.v, true,function(){
    libLocation.goTo(INR.URL.FW2_BLOCKINVITATION_SUCCESS);
  });

});
ApiServer["custom.signup1"] = async function(form : HTMLFormElement){
  const
    identifier = form.a00identifier.value,
    password =  form.a00password.value;

  invitationReceived = {invitation:{firstname:form.a01firstname.value},identifier};
  try{
    await createAccount(identifier,password);
    //separate call
    await Promise.all([
      ApiServer.accsetprofile({firstname:form.a01firstname.value}),
      ApiServer.accgetstate(deviceId, "WebFirebase", FizConfig.jsVersion||"",OS.getTimeZone())
    ])
    Storage.sessionSet('needsegmentidentify','true');
    ApiServer.accsendaccountidentifiervalidationcode(null,null,identifier,null,"TOKEN");
    libLocation.goTo(INR.URL.FW2_SIGNUP_FAMILY);

  }catch(e){
    modal.alert("fw2.defaultError")
  }
}

ApiServer["custom.signup2"] = ApiServer.group([
    ApiServer.acccreatefamily.prepare({cover:"/mediadefault/familyCover"}),
    ApiServer.accsetterms.prepare(true),
  ],function(){
    ApiServer.accsendwelcomeemail();
    signupSuccess();
  },function(ex){
    console.log(ex)
    modal.alert("fw2.defaultError");
});



INR.createPage(INR.URL.FW2_PROMOCODE_VOUCHER,
  startSequence,
  function(){
    return Promise.all([import('./nc/promocode_voucher.mustache')])
  },
  "fw2"
);
INR.onPage(INR.URL.FW2_PROMOCODE_VOUCHER,function(){
  PROMOCODE.ask = true;
  PROMOCODE.code = libLocation.getURLParam('promo');
  Storage.sessionSet('PROMOCODE',JSON.stringify(PROMOCODE));
});

INR.createPage(INR.URL.FW2_PROMOCODE,
  startSequenceWithFamilies,
  function(){
    return Promise.all([import('./nc/promocode.mustache')])
  },
  "fw2"
);
INR.onPage(INR.URL.FW2_PROMOCODE,function(){
  if(PROMOCODE.code){
    Storage.sessionRemove('PROMOCODE');
    const ncLayouts = document.querySelectorAll('.nc-layout');
    ncLayouts.forEach((el: Element) => {
      (el as HTMLElement).style.display = 'none';
    });
    const valueInput = document.querySelector("input[name='a01value']") as HTMLInputElement;
    if (valueInput) {
      valueInput.value = PROMOCODE.code;
    }
    const form = document.querySelector("form") as HTMLFormElement;
    if (form) {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  }
});

INR.createPage(INR.URL.FW2_TERMS,
  startSequenceWithFamilies,
  function(){
    return Promise.all([import('./nc/terms.mustache')])
  },
  "fw2"
);


ApiServer["custom.promocode"] = ApiServer.group([ApiServer.famlogfamily,ApiServer.creditusepromocode],function(){
  if(PROMOCODE.signup){
    if(OS.hasApp){
      libLocation.goTo(INR.URL.FW2_INVITATION_SUCCESS);
    }else{
      libLocation.goTo(INR.URL.ENTER_HOME+"?modal=welcome");
    }
  }else{
    libLocation.goTo(INR.URL.ENTER_HOME+"?modal=promocode");
  }

},function(ex){
  const ncLayouts = document.querySelectorAll('.nc-layout');
  ncLayouts.forEach((el: Element) => {
    (el as HTMLElement).style.display = '';
  });
  if(ex.code==='403'){
    modal.alert("fw4.promocode.error");
  }else{
    modal.alert("fw2.defaultError");
  }

});

INR.createPage(
  "familypick.php",
  startSequenceWithFamilies,
  function(){
    return Promise.all([import('./nc/pickfamily.mustache')])
  },
  "fw2",
);

INR.createPage(
  INR.URL.EMAIL_VALIDATE,
  startSequenceDeepLink,
  function(){
    return Promise.all([import('./nc/email_validate.mustache')])
  },
  "fw2",
);

Html.registerDom({
  saverecipefamily(metaId){
    ApiServer.famlogfamily(metaId);
    let
      recipeToSave = getRecipeToSave();

    ApiServer.mprecipeput(recipeToSave,recipeToSave.pictures,function(savedRecipe){
      Storage.sessionRemove('recipeToSave');
      libLocation.goTo("recipebox.php?id="+savedRecipe.metaId);
    })
  }
})

function getRecipeToSave(){
  let
    recipeToSaveString = Storage.sessionGet('recipeToSave');

  if(recipeToSaveString) {
    let
      recipeToSaveJson = JSON.parse(recipeToSaveString),
      result = new ApiServer.types.RecipeInputBean(recipeToSaveJson);

    result.metaId = null;
    result.pictures = recipeToSaveJson.medias.map(media=>media.pictureUrl);
    return result;
  }else{
    return null;
  }


}

INR.createPage(
  "token.php",
  startSequence,
  function(){
    return Promise.all([import('./nc/token.mustache')])
  },
  "fw2"
);
INR.onPage("token.php",async function(){
  try{
    //clean all
    await ApiServer.log2out();
    clearAuthorization();
    //get token and dispatch
    const
      token = libLocation.getURLParam('v'),
      tokenResponse = await ApiServer.log2getdeeplinkinfo(token,'Bearer',deviceId)

    switch(tokenResponse.tokenType){
      case "MealPlannerAnonymousSharing":{
        libLocation.goTo("mealplanner_nc.php?v="+encodeURIComponent(token),true);
        return;
      }
      case "RecipeSharing":{
        libLocation.goTo("recipebox_nc.php?v="+encodeURIComponent(token)+"&metaId="+encodeURIComponent(tokenResponse.recipeId),true);
        return;
      }
      case "TimetableAnonymousSharing":{
        libLocation.goTo("timetable_nc.php?v="+encodeURIComponent(token),true);
        return;
      }
      case "ForgotPassword":{
        libLocation.goTo("password_reset.php",true);
        return;
      }
      case "AccountIdentifierValidation":{
        libLocation.goTo("email_validate.php",true);
        return;
      }
      case "Invitation":{
        libLocation.goTo("fw2_invitation.php?v="+encodeURIComponent(token)+"&iid="+encodeURIComponent(tokenResponse.invitationId),true);
        return;
      }
      case "InvitationAccepted":{
        libLocation.goTo("invitation_already_accepted.php",true);
        return;
      }
      case "DeepLoginLink":
      default:{
        libLocation.goTo("home.php",true);
        return;
      }


    }


  }catch(e){
    console.log(e)
    libLocation.goTo('error_token.php',true);
  }
});